import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../../redux/slices/employee/employeeSlice";
import {
  Button,
  DocumentsList,
  EmployeeHeader,
  InfoText,
  Modal,
  PageHeader,
  PageTitle,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { keyToTitle } from "../../../../utils/keyToTitle";
import { dateFormator } from "../../../../utils/dateFormator";
import { formatWords } from "../../../../utils/stringUtils";
import { getEmployeeId } from "../../../../utils/getEmployeeId";
import { getValueByKey } from "../../../../utils/dataMappings";
import { mapTableRows } from "../../../../utils/mapTableRows";

import EditGeneralDetailsModal from "./GeneralEducation/Modals/EditGeneralDetails";
import AddEducationDetails from "./GeneralEducation/Modals/AddEducationDetails";
import { transformFiles } from "../../../../utils/transformFiles";
import { useNavigate } from "react-router-dom";

const GeneralEducation = () => {
  const [editModal, setEditModal] = useState(false);
  const [educationModal, setEducationModal] = useState(false);
  const [editEducationModal, setEditEducationModal] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid,
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee,
  );

  const handleEmployeeSelect = (uiid) => {
    dispatch(setEmployeeProfileUiid(uiid));
    dispatch(
      getEmployeeByUiidStart({
        uiid: employeeProfileUiid,
        tab: "",
        ret: "",
      }),
    );
  };

  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("generalEducation")) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "generalEducation",
          incl: ["firstName middleName lastName employmentType"],
          ret: "firstName middleName lastName jobTitle status email mobile employmentType gender employmentType joinDate location category classification workAuthorization educationDetails managers ssn dob bloodType placements linkedTo",
          ref: "EduDoc Parent",
        }),
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch, editModal]);

  const {
    firstName,
    middleName,
    lastName,
    jobTitle,
    status,
    email,
    mobile,
    employmentType,
    gender,
    employmentTypes,
    joinDate,
    location,
    category,
    classification,
    workAuthorization,
    educationDetails,
    managers,
    linkedTo,
  } = employeeDetails || {};

  let generalDetails = [
    {
      firstName: firstName || "",
      middleName: middleName || "",
      lastName: lastName || "",
      jobTitle: jobTitle || "",
      emailAddress: email?.primary,
      contactNumber: `${mobile?.primary?.code || ""}${
        mobile?.primary?.number || ""
      }`,
      alternateEmailAddress: email?.secondary,

      gender: getValueByKey(gender, "Gender"),
      employeeId: getEmployeeId(employeeProfileUiid, employmentType),
      employeeType: getValueByKey(employmentType, "EmploymentType"),
      employeeStatus: getValueByKey(status, "EmployeeStatus"),

      hrManager: managers?.HR,
      dateOfJoining: joinDate,
      category: category,
      location: `${location?.state}, ${location?.city}`,
      classification: getValueByKey(classification, "EmployeeClassification"),
      workAuthorization,
    },
  ];
  if (employmentType === 4) {
    const {
      firstName,
      middleName,
      lastName,
      emailAddress,
      contactNumber,
      alternateEmailAddress,
      gender,
      jobTitle,
      employeeId,
      employeeType,
      employeeStatus,
      hrManager,
      dateOfJoining,
      category,
      location,
      classification,
      workAuthorization,
    } = generalDetails[0];

    generalDetails[0] = {
      firstName,
      middleName,
      lastName,
      jobTitle: formatWords("", jobTitle),
      linkedTo: [linkedTo?.firstName, linkedTo?.lastName]
        .filter(Boolean)
        .join(" "),
      emailAddress,
      contactNumber,
      alternateEmailAddress,
      gender,
      employeeId,
      employeeType,
      employeeStatus,
      hrManager,
      dateOfJoining,
      category,
      location,
      classification,
      workAuthorization,
    };
  }

  ////////////////////////
  const tableData = educationDetails || []; // Add null check with default empty array
  const navigate = useNavigate();
  const columns = [
    { key: "major", label: "Education" },
    { key: "degree", label: "Field Of Study" },
    { key: "institute", label: "Institute" },
    {
      key: "gpa",
      label: "GPA/Percentage",
      render: (row) =>
        typeof row?.gpa === "number" ? row.gpa.toFixed(2) : "--",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
    },
    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              transformFiles(row.documents || []).length > 0 && "cursor-pointer"
            }`}
            onClick={
              transformFiles(row.documents || []).length > 0
                ? () => handelDocumetsModal(transformFiles(row.documents || []))
                : () => {}
            }
          >
            <span
              className={`${
                transformFiles(row.documents || []) > 0 && "text-linkblue"
              }`}
            >
              {transformFiles(row.documents || []).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div>
            <Button
              type="icon"
              size="sm"
              color="dark"
              variant="text"
              icon="edit_square"
              onClick={() => handleEditEducationModal(row, row.__index)}
            />
          </div>
        );
      },
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  ////////////////////////

  const handleAddEducationModal = () => {
    setSelectedEducation(null);
    setEducationModal(!educationModal);
    setEditEducationModal(false);
  };
  const handleEditEducationModal = (row) => {
    setSelectedEducation({ row });
    setEducationModal(!educationModal);
    setEditEducationModal(!editEducationModal);
  };
  console.log("selectedDocuments", selectedDocuments);
  const handleCall = () => {
    let number = generalDetails[0].contactNumber;
    // const deepLink = `zoomphonecall:${encodeURIComponent(number)}`;
    const deepLink = `zoomphonecall:${encodeURIComponent(number)}`;
    console.log("deepLink", deepLink, number);
    window.location.href = deepLink;
  };
  return (
    <div className="mt-3 flex-1 flex flex-col gap-2  overflow-hidden">
      <div>
        <PageHeader
          Section={<EmployeeHeader />}
          RightSection={
            <div className="flex gap-3">
              <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                type="link"
                to="/employee"
              />
              {/* <Button
                color="primary"
                size="sm"
                title={"Back"}
                icon={"west"}
                // onClick={() => navigate("/employee/employee-profile#overview")}
                onClick={() =>
                  navigate("/employee/employee-profile?profile-info=overview")
                }
              /> */}
              {/* <Button
                color="primary"
                size="sm"
                title={"Next"}
                icon={"east"}
                iconPosition="after"
                // onClick={() =>
                //   navigate("/employee/employee-profile#work-authorization")
                // }
                onClick={() =>
                  navigate(
                    "/employee/employee-profile?profile-info=work-authorization&work-authorization-main=overview",
                  )
                }
              /> */}
            </div>
          }
        />
      </div>
      <div className="flex-1 flex flex-col gap-2 overflow-auto pr-2">
        <div className="inner-section px-5 py-3">
          <PageHeader
            Section={
              <div className="flex justify-start">
                <PageTitle title={"General Details"} icon={"person"} tag="h6" />
              </div>
            }
            RightSection={
              <div className="flex gap-3 items-center">
                <Button
                  title={"Edit"}
                  icon={"edit_square"}
                  size="sm"
                  onClick={() => setEditModal(!editModal)}
                />
              </div>
            }
          />
          <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-3">
            {Object.entries(generalDetails[0]).map(([key, value]) => {
              // Check if value is a date string
              const isDateValue =
                /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value);

              if (key === "contactNumber") {
                return (
                  <div className="flex  gap-4 items-center" key={key}>
                    <InfoText
                      size="sm"
                      title={keyToTitle(key)}
                      value={
                        isDateValue
                          ? dateFormator(value, "short")
                          : value || "--"
                      }
                    />
                    <SmartTooltip
                      noicon
                      description={"Zoom Call"}
                      tooltipPosition={"top"}
                      variant="outlined"
                      color="primary"
                    >
                      <Button
                        type="icon"
                        variant="outlined"
                        icon="call"
                        size="sm"
                        color="primary"
                        onClick={handleCall}
                      />
                    </SmartTooltip>
                  </div>
                );
              }
              if (key === "emailAddress") {
                return (
                  <div className="flex  gap-4 items-center" key={key}>
                    <InfoText
                      size="sm"
                      title={keyToTitle(key)}
                      value={
                        isDateValue
                          ? dateFormator(value, "short")
                          : value || "--"
                      }
                    />
                    <SmartTooltip
                      noicon
                      description={"Send Mail"}
                      tooltipPosition={"top"}
                      variant="outlined"
                      color="primary"
                    >
                      <Button
                        type="icon"
                        variant="outlined"
                        icon="email"
                        size="sm"
                        color="primary"
                        onClick={() => window.open(`mailto:${value}`)}
                      />
                    </SmartTooltip>
                  </div>
                );
              }

              return (
                <InfoText
                  size="sm"
                  key={key}
                  title={keyToTitle(key)}
                  value={
                    isDateValue ? dateFormator(value, "short") : value || "--"
                  }
                />
              );
            })}
          </div>
        </div>
        <div className="inner-section px-5 py-3 flex flex-1 flex-col overflow-hidden min-h-[360px]">
          <PageHeader
            Section={
              <div className="flex justify-start">
                <PageTitle
                  title={"Education Details"}
                  icon={"school"}
                  tag="h6"
                />
              </div>
            }
            RightSection={
              <div className="flex gap-3 items-center">
                <Button
                  title={"Add"}
                  icon={"add"}
                  size="sm"
                  onClick={handleAddEducationModal}
                />
              </div>
            }
          />

          <div className="mt-3 flex flex-col overflow-hidden">
            <TableAdv
              tableId={`employees_generaleducation`}
              rows={mappedRows}
              columns={columns}
              hideToolBar
            />
          </div>
        </div>
      </div>
      <EditGeneralDetailsModal
        editModal={editModal}
        setEditModal={setEditModal}
        edit
      />
      <AddEducationDetails
        isOpen={educationModal}
        onClose={setEducationModal}
        edit={editEducationModal}
        educationData={selectedEducation}
      />
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default GeneralEducation;
